import { Button, Col, DatePicker, Input, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { search } from 'src/api/user'
import { fetchCountryProvider } from 'src/api/authen'
import { countryCodes, mncmccOptions, paymentSources, userType } from 'src/constants'

interface UserSearchProps {
  appendSearchForm: (obj) => void
  submitSearchForm: (obj?: any) => void
}

const UserSearch: React.FC<UserSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [loading, setLoading] = useState(false)
  const [providerCountry, setProviderCountry] = useState('')
  const [countries, setCountries] = useState([])
  const [selectedValue, setSelectedValue] = useState(undefined);
  const handleSearch = React.useCallback(async (value) => {
    if (!value) return
    setLoading(true)
    const data = await search({ name: value, size: 50 })

    setLoading(false)
  }, [])
  const { Option } = Select
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const data = await fetchCountryProvider()
        const countryOptions = data.data.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        }))
        setCountries(countryOptions)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchCountry()
  }, [])
  const handleDateChange = (date, dateString) => {
    appendSearchForm({ joinedOn: dateString });
  };
  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' });
    submitSearchForm();
   
    setTimeout(() => {
      appendSearchForm({ buttonAction: '' });
    }, 100);
  };

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' });
    submitSearchForm();
    setTimeout(() => {
      appendSearchForm({ buttonAction: '' });
    }, 100);
  };
  const handleSelect = (value) => {
    if (value === 'pdf') {
      handlePdfClick();
    } else if (value === 'csv') {
      handleCsvClick();
    }
    
    setTimeout(() => setSelectedValue(undefined), 100);
  };
  const allUserTypeOptions = [
    { label: 'All', value: 'ALL' },
    ...userType,
  ];
  const allPaymentSourceOptions = [
    { label: 'All', value: 'ALL' },
    ...paymentSources,
  ];
  const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');
  const [selectedPaymentSourceValue, setSelectedPaymentSourceValue] = useState('ALL');
  const handleFilterChange = (value) => {
    setSelectedFilterValue(value);
    let userTypesForSearch;

    if (value === 'ALL') {
     
      userTypesForSearch = userType.map(option => option.value);
    } else {
      
      userTypesForSearch = [value];
    }

    appendSearchForm({ userAccessType: userTypesForSearch });
    submitSearchForm(); 
  };

  const handleClear = () => {
    setSelectedFilterValue('ALL'); 
    const userTypesForClear = userType.map(option => option.value);
    console.log('user clear' ,selectedFilterValue)
    appendSearchForm({ userAccessType: userTypesForClear });
    submitSearchForm(); 
  };
  const handlePaymentSourceChange = (value) => {
    setSelectedPaymentSourceValue(value);
    let paymentTypesForSearch;

    if (value === 'ALL') {
     
paymentTypesForSearch = [...paymentSources.map(option => option.value), "null"];
    } else {
      
      paymentTypesForSearch = [value];
    }
    appendSearchForm({ paymentSource: paymentTypesForSearch });
    submitSearchForm(); 
    
  };
  return (
    <div>
  <Row gutter={[8, 8]}>
    <Col span={4}>
      <Input
        placeholder="Name"
        allowClear
        onChange={(e) => {
          appendSearchForm({ name: e.target.value });
          if (e.target.value === '') submitSearchForm();
        }}
        className="search-input"
      />
    </Col>
    <Col span={4}>
      <Input
        placeholder="User Name"
        allowClear
        onChange={(e) => {
          appendSearchForm({ username: e.target.value });
          if (e.target.value === '') submitSearchForm();
        }}
        className="search-input"
      />
    </Col>
    <Col span={4}>
      <Input
        placeholder="User Id"
        allowClear
        onChange={(e) => {appendSearchForm({ userId: e.target.value.trim() });
        if (e.target.value === '') submitSearchForm();
        }}
        className="search-input"
      />
    </Col>
    <Col span={4}>
      <Input
        placeholder="Email"
        allowClear
        onChange={(e) => {appendSearchForm({ email: e.target.value });
        if (e.target.value === '') submitSearchForm();
        }}
        className="search-input"
      />
    </Col>
    <Col span={8}>
              <DatePicker.RangePicker
                
                allowClear
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={(dates) => {
                  const startDate = dates?.[0]?.format('YYYY-MM-DD') || null
                  const endDate = dates?.[1]?.format('YYYY-MM-DD') || null
                  appendSearchForm({ startDate, endDate })
                }}
              />
            </Col>
    
	
    
    
  </Row>

  <Row gutter={[8, 8]} style={{ marginTop: 8 }}>
    <Col span={4} >
    <Select
        placeholder="User Type" 
        onChange={handleFilterChange}
        value={selectedFilterValue} 
       
        onClear={handleClear} 
     
        className="search-input" 
      >
        {allUserTypeOptions.map(option => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Col>
     <Col span={4} >
    <Select
        placeholder="Payment Source" 
        onChange={handlePaymentSourceChange}
        value={selectedPaymentSourceValue} 
      
        className="search-input" 
      >
        {allPaymentSourceOptions.map(option => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Col>
  <Col span={4}>
      <Select
        placeholder="Provider Country"
        onChange={(value) => {
          appendSearchForm({ providerCountry: value });
          if (!value) submitSearchForm();
        }}
        allowClear
        onClear={() => {
          appendSearchForm({ providerCountry: '' });
          submitSearchForm();
        }}
        showSearch
        className="search-input"
        style={{ width: '100%' }}
      >
        {countries.map((country) => (
          <Select.Option value={country.value} key={country.value}>
            {country.label}
          </Select.Option>
        ))}
      </Select>
    </Col>
    
  
    <Col span={4}>
    <Select
    placeholder="Source "
    onChange={(value) => {
      appendSearchForm({ mncmcc: value });
      if (!value) submitSearchForm();
    }}
    allowClear
    onClear={() => {
      appendSearchForm({ mncmcc: '' });
      submitSearchForm();
    }}
    showSearch
    className="search-input"
    style={{ width: '100%' }}
    filterOption={(input, option) =>
      (option?.label?.toString().toLowerCase() || '').includes(input.toLowerCase())
    }
  >
    {mncmccOptions.map(({ value, label }) => (
      <Select.Option value={value} key={value}>
        {label}
      </Select.Option>
    ))}
  </Select>
    </Col>
  <Col span={4}>
   
    
  <Select
  placeholder="Country Code"
  onChange={(value) => {appendSearchForm({ countryCode: value });
  if (!value) submitSearchForm();
}}
  allowClear
  onClear={() => {appendSearchForm({ countryCode: '' });
  submitSearchForm();
}}
  showSearch
  className="search-input"
  style={{ width: '100%' }}
  filterOption={(input, option) => {
    const value = option?.value?.toString().toLowerCase() || '';
    const label = option?.children?.toString().toLowerCase() || '';
    return (
      value.includes(input.toLowerCase()) ||
      label.includes(input.toLowerCase())
    );
  }}
>
  {countryCodes.map(({ code, name }) => (
    <Select.Option key={code} value={code}>
      {code} ({name})
    </Select.Option>
  ))}
</Select>
      </Col>
      <Col span={4}>
      <Input
        placeholder="Phone Number"
        allowClear
        onChange={(e) => {appendSearchForm({ phoneNumber: e.target.value });
        if (e.target.value === '') submitSearchForm();
        }}
        className="search-input"
      />
    
  </Col>
    
    <Col span={4}>
      <Button
        type="primary"
        icon={<SearchOutlined />}
        onClick={() => submitSearchForm()}
        className="btn-primary"
        style={{ width: '100%' }}
      >
        Search
      </Button>
    </Col>
  </Row>
  <Row justify="end" align="middle" style={{ marginBottom: 10 }}>
  
  <Col>
  <Select
      placeholder="Export"
      style={{ width: 160 }}
      onSelect={handleSelect}
      allowClear
      value={selectedValue}
    >
      <Select.Option value="pdf">Export as PDF</Select.Option>
      <Select.Option value="csv">Export as CSV</Select.Option>
    </Select>
  </Col>
</Row>
</div>
  )
}

UserSearch.displayName = 'UserSearch'
export default UserSearch
